import { MaybeUndef } from '../../types/system';

export interface PayloadExtractor<SuccessPayload, ErrorPayload> {
  extractListSuccessPayload(payload: any): SuccessPayload;
  extractListErrorPayload(payload: any): ErrorPayload;
}

export enum PredefinedPayloadExtractor {
  CallApi = 'CallApi',
}

export type PayloadExtractorOptions = PredefinedPayloadExtractor.CallApi;

export function createPayloadExtractor<SuccessPayload, ErrorPayload>(
  options: MaybeUndef<PayloadExtractorOptions>,
): PayloadExtractor<SuccessPayload, ErrorPayload> {
  if (!options) {
    return {
      extractListSuccessPayload: (payload: any) => payload,
      extractListErrorPayload: (payload: any) => payload,
    };
  }

  if (options === PredefinedPayloadExtractor.CallApi) {
    return {
      extractListSuccessPayload: (payload: any) =>
        payload.responsePayload || payload.rawResponse,
      extractListErrorPayload: (payload: any) => payload.rawResponse,
    };
  }

  throw new Error(`Cannot find payload extractor for options: ${options}`);
}
